import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import CrmIncomingCallListener from '../CrmIncomingCallListener';
import { brand } from '../../theme';

const AdminLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden',
        bgcolor: brand.bg,
        '@supports (height: 100dvh)': {
          height: '100dvh',
          maxHeight: '100dvh'
        }
      }}
    >
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={() => setIsSidebarCollapsed((v) => !v)}
      />
      {/* Permanent Drawer already reserves width in this flex row — do not add ml. */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          minHeight: 0
        }}
      >
        <Header />
        <Box
          component="main"
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            p: { xs: 1.5, md: 2 }
          }}
        >
          <CrmIncomingCallListener />
          <Box sx={{ width: '100%', maxWidth: '100%' }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;
